import { getAttendanceStatus, getAttendanceStatusColor } from "@/lib/methodUtils";
import { Tooltip } from "@mui/material";
import React from "react";

interface Props {
  status: string;
  colorStatus?: string;
  size?: number;
}

const AttendanceBadge: React.FC<Props> = ({ status, colorStatus, size = 26 }) => {
  if (!status) return <>-</>;

  return (
    <Tooltip title={status || ""}>
      <span
        style={{
          width: size,
          height: size,
          borderRadius: "50%",
          backgroundColor: getAttendanceStatusColor(colorStatus ? colorStatus : status),
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#fff",
          fontSize: "0.8rem",
          fontWeight: "bold",
          margin: "auto",
        }}
      >
        {getAttendanceStatus(status)}
      </span>
    </Tooltip>
  );
};

export default AttendanceBadge;